
export default function validator() {
    return {

        email: (value: string) => {
            if (!value) return 'Email is required';
            if (!/^[a-z0-9@._]+$/i.test(value)) return 'Email can only contain letters, numbers, @, ., and _';
            if (!/\S+@\S+\.\S+/.test(value)) return 'Email is invalid';
            return null;
        },
        username: (value: string) => {
            if (!value) return 'Username is required';
            if (value.length < 3 || value.length > 20) return 'Username must be at least 3 & max 20 characters';
            // Username can contain letters, numbers, and single spaces between words (no leading/trailing/multiple spaces)
            if (!/^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/.test(value)) {
                return 'Username can only contain letters, numbers, and single spaces between words';
            }
            return null;
        },
        password: (value: string) => {
            if (!value) {
                return 'Password is required';
            }
            const isValid = value.length >= 8 && 
                /[A-Z]/.test(value) &&
                /[a-z]/.test(value) &&
                /[0-9]/.test(value) &&
                /[^A-Za-z0-9]/.test(value);

            if (!isValid) {
                return 'Password must be at least 8 characters and include uppercase, lowercase, number, and symbol.';
            }
            return null;
        },
        dob: (value?: string) => {
            if (!value) return null;
            const dob = new Date(value);
            if (isNaN(dob.getTime())) return 'Date of birth is invalid';
            const today = new Date();
            let age = today.getFullYear() - dob.getFullYear();
            const m = today.getMonth() - dob.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
                age--;
            }
            if (age < 18) return 'You must be at least 18 years old';
            return null;
        },

    };
}

/*
Example usage in a page or component:


const validate = validator();

const emailError = validate.email('test@example.com'); // null (valid)
const passwordError = validate.password('123'); // 'Password must be at least 6 characters
*/

// password: (value: string) => {
//     if (!value) return 'Password is required';
//     if (value.length < 8) return 'Password must be at least 8 characters';
//     if (!/[A-Z]/.test(value)) return 'Password must contain at least one uppercase letter';
//     if (!/[a-z]/.test(value)) return 'Password must contain at least one lowercase letter';
//     if (!/[0-9]/.test(value)) return 'Password must contain at least one number';
//     if (!/[^A-Za-z0-9]/.test(value)) return 'Password must contain at least one symbol';
//     return null;
// },
